export default function HowItWorks() {
  const steps = [
    {
      step: '01',
      title: 'Find Products',
      description: 'Browse and discover products across multiple categories and suppliers that match your sourcing needs.',
      icon: 'ri-search-line',
    },
    {
      step: '02',
      title: 'Add Product Information',
      description: 'Log key details including prices, supplier info, product specs, and links into your spreadsheet structure.',
      icon: 'ri-file-add-line',
    },
    {
      step: '03',
      title: 'Compare Options',
      description: 'Use built-in comparison views to evaluate products side by side based on price, quality, and supplier reliability.',
      icon: 'ri-arrow-left-right-line',
    },
    {
      step: '04',
      title: 'Track Purchase Status',
      description: 'Monitor each order from placement through shipping to delivery with status tracking columns.',
      icon: 'ri-truck-line',
    },
    {
      step: '05',
      title: 'Complete Optimized Buying',
      description: 'Make confident, data-backed purchasing decisions and complete your optimized shopping workflow.',
      icon: 'ri-check-double-line',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            How It Works
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
            How Superbuy Spreadsheet Works
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            A simple five-step workflow that transforms how you research and purchase products
          </p>
        </div>

        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-background-200/70"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
            {steps.map((step, index) => (
              <div key={step.step} className="relative text-center group">
                {/* Step number */}
                <div className="relative z-10 w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-lg md:text-xl font-semibold mb-4 group-hover:scale-110 transition-transform duration-300">
                  {step.step}
                </div>
                {/* Arrow for mobile */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center mb-3">
                    <i className="ri-arrow-down-line text-foreground-300 text-lg"></i>
                  </div>
                )}
                <h3 className="font-semibold text-sm md:text-base text-foreground-950 mb-2">{step.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed max-w-[200px] mx-auto">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}